module.exports = __webpack_public_path__ + "static/media/icon-blue-location-pin.9b59c14d.png";